import { createStructuredSelector } from 'reselect';


const ADD_ITEM = 'cam4/items/ADD_ITEM';
const DELETE_ITEM = 'cam4/items/DELETE_ITEM';

export const NAME = 'items';

const initialState = { items: [] };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_ITEM: {
      return {
        ...state,
        items: state.items.concat([{ title: action.title }]),
      };
    }

    case DELETE_ITEM:
      return {
        ...state,
        items: state.items.filter((item) => item.title !== action.title),
      };

    default:
      return state;
  }
}

function addItem(title) {
  return {
    type: ADD_ITEM,
    title,
  };
}

function deleteItem(title) {
  return {
    type: DELETE_ITEM,
    title,
  };
}

const items = (state) => state[NAME];

export const selector = createStructuredSelector({ items });

export const actionCreators = {
  addItem,
  deleteItem,
};
